/**
 * Charava custom PDP blocks — shared behaviour.
 * Loaded once from layout/theme.liquid.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * CTA buttons that anchor back up to the buybox.
   * ---------------------------------------------------------------- */
  var BUYBOX_TARGETS = [
    '#buybox',
    '[data-pdp-buybox]',
    '.product-info',
    '.shopify-section--main-product',
    '#shopify-section-main'
  ];

  function findBuybox() {
    for (var i = 0; i < BUYBOX_TARGETS.length; i++) {
      var el = document.querySelector(BUYBOX_TARGETS[i]);
      if (el) return el;
    }
    return null;
  }

  function headerOffset() {
    var header = document.querySelector('.header, #shopify-section-header');
    if (!header) return 0;

    var position = window.getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;

    return header.getBoundingClientRect().height;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pdp-buybox-anchor]');
    if (!trigger) return;

    var target = findBuybox();
    if (!target) return;

    event.preventDefault();

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  });

  /* ------------------------------------------------------------------
   * Accordion — keeps a single item open when the section asks for it.
   * ---------------------------------------------------------------- */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('.pdp-accordion__item')) return;
    if (!details.open) return;

    var list = details.closest('[data-pdp-accordion-single]');
    if (!list) return;

    list.querySelectorAll('.pdp-accordion__item[open]').forEach(function (item) {
      if (item !== details) item.open = false;
    });
  }, true);

  /* ------------------------------------------------------------------
   * Video carousel — arrow buttons scroll the track by one slide.
   * ---------------------------------------------------------------- */
  function step(track) {
    var slide = track.querySelector('li');
    if (!slide) return track.clientWidth;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function syncNav(carousel) {
    var track = carousel.querySelector('[data-pdp-carousel-track]');
    var prev = carousel.querySelector('[data-pdp-carousel-prev]');
    var next = carousel.querySelector('[data-pdp-carousel-next]');
    if (!track) return;

    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;

    var dots = carousel.querySelectorAll('[data-pdp-carousel-dot]');
    if (!dots.length) return;

    var current = Math.round(track.scrollLeft / step(track));
    if (current > dots.length - 1) current = dots.length - 1;
    if (current < 0) current = 0;

    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === current);
      dot.setAttribute('aria-current', index === current ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pdp-carousel-prev], [data-pdp-carousel-next]');
    if (!button) return;

    var carousel = button.closest('[data-pdp-carousel]');
    var track = carousel && carousel.querySelector('[data-pdp-carousel-track]');
    if (!track) return;

    var direction = button.hasAttribute('data-pdp-carousel-next') ? 1 : -1;
    track.scrollBy({ left: direction * step(track), behavior: 'smooth' });
  });

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-pdp-carousel-dot]');
    if (!dot) return;

    var carousel = dot.closest('[data-pdp-carousel]');
    var track = carousel && carousel.querySelector('[data-pdp-carousel-track]');
    if (!track) return;

    var index = parseInt(dot.getAttribute('data-pdp-carousel-dot'), 10) || 0;
    track.scrollTo({ left: index * step(track), behavior: 'smooth' });
  });

  document.querySelectorAll('[data-pdp-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-pdp-carousel-track]');
    if (!track) return;
    syncNav(carousel);
    track.addEventListener('scroll', function () { syncNav(carousel); }, { passive: true });
    window.addEventListener('resize', function () { syncNav(carousel); });
  });

  /* ------------------------------------------------------------------
   * Video slides — the overlay play button starts the clip and hands
   * over to the native controls.
   * ---------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pdp-video-play]');
    if (!button) return;

    var frame = button.closest('.pdp-video__frame');
    var video = frame && frame.querySelector('video');
    if (!video) return;

    video.controls = true;
    frame.classList.add('is-playing');
    video.play();
  });

  document.addEventListener('pause', function (event) {
    var video = event.target;
    if (!video.matches || !video.matches('.pdp-video__frame video')) return;
    var frame = video.closest('.pdp-video__frame');
    if (frame && video.currentTime === 0) frame.classList.remove('is-playing');
  }, true);
})();
